"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InputRow;

var _react = _interopRequireDefault(require("react"));

var _underscore = _interopRequireDefault(require("underscore"));

require("./InputRow.less");

function InputRow(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children;
  var index = 0;

  var filteredChildren = _underscore.default.filter(_react.default.Children.toArray(children), function (child) {
    return typeof child !== 'undefined' && child != null;
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-row ".concat(className)
  }, _react.default.Children.map(filteredChildren, function (child) {
    if (filteredChildren.length > 1) {
      var _className = child.props.className || '';

      if (index === 0) {
        _className += ' first-in-row';
      } else if (index + 1 === filteredChildren.length) {
        _className += ' last-in-row';
      } else {
        _className += ' middle-in-row';
      }

      index++;
      return /*#__PURE__*/_react.default.cloneElement(child, {
        className: _className
      });
    }

    return child;
  }));
}